<template>
  <div class="business-income-table">
    <div class="default-table" style="padding: 2px 2px"
         v-loading="loadingStatus"
         element-loading-text="加载中……"
         element-loading-spinner="el-icon-loading">
      <MlPageTable :show-slot='loadingStatus'
                   :all-columns='userColumns'
                   :table-name='tableName'
                   :data-list='dataList'
                   :limit.sync='pagingData.page_size'
                   :page.sync='pagingData.current_page'
                   :total.sync='pagingData.total'
                   :show-index='true'
                   :height-value="height"
                   highlight-current-row
                   @sort-change='changeTableSort'
                   @getList='initList'
                   @select="handleSelectRow"
                   @selection-change="handleSelectionChange"
                   @select-all="HandleSelectAll"
                   ref="elAdIncomeTable"
                   stripe
                   :border="true">
        <el-table-column slot="first-column" type="selection" width="55"/>
        <el-table-column prop="agent_name"
                         label="经纪人"
                         header-align="center"
                         align="center"
                         width="160"
                         slot="agent_name">
          <template slot-scope="{row}">
            <b>{{ row.agent_name }}
              <span v-if="row.user_aid" :title="`转交时间：${row.transfer_at}`">
                  <span class="el-icon-right" style="color: red"></span>
                『{{ row.assistant.name || '--' }}』
              </span>
            </b>
          </template>
        </el-table-column>
        <el-table-column prop="is_confirm"
                         label="确认状态"
                         header-align="center"
                         align="center"
                         width="120"
                         slot="is_confirm_alias">
          <template slot-scope="{row}">
            <el-tag v-if="row.is_confirm === 'Y'" type="success" size="mini">{{row.is_confirm_alias?row.is_confirm_alias:'已确认'}}</el-tag>
            <b v-else>{{row.is_confirm_alias?row.is_confirm_alias:'未确认'}}</b></template>
        </el-table-column>
        <el-table-column prop="confirm_type" label="确认类型" header-align="center" align="center" width="120" slot="confirm_type" />
        <el-table-column
            v-if="hasOptColumn&&needOperate"
            key="操作项"
            label="操作项"
            slot="handle-column"
            header-align="center"
            align="left"
            width="160"
            fixed="right"
        >
          <template slot-scope="scope">
            <AdOptColumn :row="scope.row" :row-index="scope.$index"
                         @refreshOrderList="refreshOrderList"
                         @goDetail="goDetail"
                         @goView="goView"
            />
          </template>
        </el-table-column>
        <div slot="footer">
          <div class="bottom-bar">
            <el-button size="mini" @click="clearData" :disabled="previewOrderTotal===0">清空已选
            </el-button>
            <div
                style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;display: flex;align-items: center;">
              <div style="font-weight: bold;display: flex">
                  <span style="margin-right: 10px">总含税收入：
                    <span class="money" style="font-size: 1.2rem">{{
                        moneyFormat(paymentAccountTotal)
                      }}（{{ moneyFormat(total_amount) }}）</span>
                  </span>
              </div>
            </div>
            <div
                style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;display: flex;align-items: center;">
              <div style="font-weight: bold;display: flex">
                  <span style="margin-right: 10px">总广告收入：
                    <span class="money" style="font-size: 1.2rem">{{
                        moneyFormat(advRevenueTotal)
                      }}（{{ moneyFormat(adv_total_amount) }}）</span>
                  </span>
              </div>
            </div>
            <div
                style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;display: flex;align-items: center;">
              <div style="font-weight: bold;display: flex">
                  <span style="margin-right: 10px">总执行价：
                    <span class="money" style="font-size: 1.2rem">{{
                        moneyFormat(execPriceTotal)
                      }}（{{ moneyFormat(exec_total_amount) }}）</span>
                  </span>
              </div>
            </div>
          </div>
        </div>
      </MlPageTable>

    </div>

  </div>
</template>

<script>
import AdOptColumn from "@/views/adOrder/components/AdOptColumn";
import {businessIncomeList, getBusinessIncomeAssistantList} from "@/api/incomeSummary";
import MlPageTable from '@/components/MSettingColumn/MlPageTable.vue'
import {module_config} from '@/components/MSettingColumn/index.js'
import defaultColumns from './columns.json'

export default {
  name: "BusinessIncomeTable",
  components: {
    AdOptColumn,
    MlPageTable
  },
  props: {
    readonly: Boolean,
    selectedData: {
      type: Array,
      default() {
        return []
      }
    },
    needOperate: {
      type: Boolean,
      default() {
        return true
      }
    },
    queryParams: {
      type: Object
    },
    height: {type: [String, Number], default: "auto"},
  },
  computed: {
    // searchCondition: {
    //   get() {
    //     return this.queryParams
    //   },
    //   set(val) {
    //     this.$emit('queryParams', val)
    //
    //   }
    // },
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    //计算总含税收入
    paymentAccountTotal() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.payment_account / 1
      })
      return total
    },
    previewOrderTotal() {
      return this.selectedData.length
    },
    // 总广告收入
    advRevenueTotal() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.adv_revenue / 1
      })
      return total
    },
    // 总执行价
    execPriceTotal() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.exec_price / 1
      })
      return total
    },
    hasOptColumn() {
      if (this.readonly) {
        return false
      }
      return this.userAuth.can_exec_adv_order || this.userAuth.strike_balance_but || this.userAuth.option_delete_adv_order || this.userAuth.option_undo_adv_order || this.userAuth.can_create_adv_order || this.userAuth.can_update_adv_order;
    }
  },
  created() {
    // this.getTableThead()
  },
  mounted() {
    // this.initList()
  },
  data() {
    return {
      tableRef: 'elAdIncomeTable',
      // 表格列表数据
      dataList: [],
      searchCondition: {},
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20,
        current_page: 1,
        // offset: 0
      },
      // 分页的offset,序号列使用
      offset: 0,
      columns: [],
      columnsExclude: [],//循环排除，特定样式
      loadingStatus: false,
      // searchCondition: {},
      sum_amount: 0,
      total_amount: 0,
      adv_total_amount: 0,
      exec_total_amount: 0,
      tableName: 'business_income_table',
      editableCols: [],
      menuList: {
        edit: false,
        log: false,
        del: false,
        copy: false
      },
      userColumns: defaultColumns
    }
  },
  // watch: {
  //   searchCondition: {
  //     immediate: true,
  //     deep: true,
  //     handler() {
  //       this.$nextTick(() => {
  //         this.initList(true)
  //       })
  //     }
  //   }
  // },
  methods: {
    //清空选中
    handleClearSelection() {
      if (this.$refs["elAdIncomeTable"])
        this.$refs["elAdIncomeTable"].clearSelection()
    },
    changeTableSort({prop, order}) {
      // let orderSort = {}
      // if (order) {
      //   orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      // }
      this.searchCondition.orderBy = `\`${prop}\` ${order === 'descending' ? 'desc' : 'asc'}`
      this.initList()
    },
    clearData() {
      this.$emit('clearData')
    },
    // 渲染选中
    toggleSelection() {
      const data = this.dataList ? this.dataList : [];

      this.$nextTick(function () {
        data.forEach(row => {
          if (this.selectedData.findIndex(value => value.id === row.id) > -1) {
            this.switchRowSelection(row, true)
          }
        });
      });
    },
    switchRowSelection(row, bool) {
      if (this.$refs['elAdIncomeTable'])
        this.$refs['elAdIncomeTable'].toggleRowSelection(row, bool)
    },
    //当选择项发生变化时会触发该事件
    HandleSelectAll(selection) {

      if (selection.length === 0) {
        //取消全选
        // console.log('取消全选')
        // 取消的数据对象 dataList
        this.dataList.forEach((row) => {
          let index = this.selectedData.findIndex(value => value.id === row.id)
          if (index > -1)
            this.selectedData.splice(index, 1)
        })
      }
    },
    // // 行选中、取消选中
    handleSelectRow(selection, row) {
      // console.log('行选中、取消选中:'+row.id)
      if (selection.indexOf(row) === -1) {
        //row 取消选中
        // console.log('取消选中')
        let index = this.selectedData.findIndex(value => value.id === row.id)
        // this.$notify.info(`取消第${index}行`)
        if (index > -1)
          this.selectedData.splice(index, 1)
      }
    },
    handleCancelSelect(row) {
      let index = this.selectedData.findIndex(value => value.id === row.id)
      // this.$notify.info(`取消第${index}行`)
      if (index > -1) {
        let tbRow = this.dataList.find(value => value.id === row.id)
        this.switchRowSelection(tbRow, false)
        this.selectedData.splice(index, 1)
      }
    },

    init() {
      this.initList()
    },
    // 勾选事件
    handleSelectionChange(selection) {
      // console.log('handleSelectionChange')
      this.selectList = [...selection]
      this.$emit('handleSelectionChange', selection)
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2, '.', ',', 'round')
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}

      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field] != null) {
          condition[field] = this.searchCondition[field]
        }
      })

      return condition
    },
    handleQuery(query) {
      this.pagingData.current_page = 1
      this.searchCondition = {...query}
      //清空勾选
      this.initList()
    },
    async initList(isSearch = false) {
      this.dataList = []
      if (isSearch) {
        this.clearData()
      }

      let searchCondition = this.handleSearchCondition();

      Object.assign(searchCondition, {page: this.pagingData.current_page, per_page: this.pagingData.page_size})
      this.loadingStatus = true
      let result = null;
      if (this.searchCondition.scope_type === 'all') {
        result = await businessIncomeList(searchCondition);
      } else {
        result = await getBusinessIncomeAssistantList(searchCondition);
      }

      const {success, model} = result
      this.loadingStatus = false
      if (!success) {
        return;
      }

      const {data, total, current_page, per_page, sum_amount, adv_amount_total, exec_amount_total} = model

      this.dataList = data || []
      this.pagingData.total = total
      this.offset = (current_page - 1) * per_page
      // 合计含税收入
      this.total_amount = sum_amount
      // 合计广告收入
      this.adv_total_amount = adv_amount_total
      // 合计执行价
      this.exec_total_amount = exec_amount_total

      await this.$nextTick()
      // await this.toggleSelection()


    },

    //表头
    async getTableThead() {
      this.columns = [];
      let tableCols = module_config.BUSINESS_INCOME_TABLE.defaultColumns
      this.userColumns = [...tableCols]
      this.$emit('tableColumns', this.userColumns)
    },
    refreshOrderList() {
      this.$emit('refreshOrderList')
    },
    goDetail(row) {
      this.$emit('goDetail', row)
    },

    goView(row) {
      this.$emit('goDetail', row)
    },
  }
}
</script>

<style lang="scss" scoped>
.business-income-table {
  height: 100%;

  .default-table {
    height: 100%;
    //width: 98%;
  }

  .page-footer {
    height: 50px;
    width: 100%;
    position: fixed;
    bottom: 1px;
    background-color: #FFFFFF;
    opacity: 0.9;
    z-index: 999;
  }

  .bottom-bar {
    width: 100%;
    /*margin-top: 10px;*/
    text-align: left !important;
    padding: 10px 10px 0 1px;
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    /*position: fixed;bottom: 1px;*/
    /*background: #FFFFFF;*/
    /*z-index: 99999;*/
    /*opacity: 0.75;*/
  }

  .table-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .el-link--inner {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      span:last-child {
        margin-left: 2px;
      }
    }

    .flag-span {
      color: #FFF !important;
      padding: 2px 4px;
      border-radius: 2px;
      cursor: pointer;
      display: inline-block;
      font-size: 12px;
      line-height: 1;
    }

    .flag-span + .flag-span {
      margin-left: 2px;
    }


  }
}


</style>
